import React from 'react';
import type { Components } from 'react-markdown';

import CliveMarkdownDisplay from '~/components/Clive/CliveMarkdownDisplay/CliveMarkdownDisplay';
import type { NumberOfLines } from '~/components/core/Molecules/Collapsible/ShowAllCollapsible';
import ShowAllCollapsible from '~/components/core/Molecules/Collapsible/ShowAllCollapsible';
import cn from '~/Utils/cn';

// Hoisted so the markdown display's memo holds; the first paragraph sits flush under the title.
const COMPONENTS: Components = {
  p: ({ children }) => <p className="mb-8 mt-12 first:mt-0 last:mb-0">{children}</p>,
};

interface NotificationMessageProps {
  message: string;
  className?: string;
  /** Clamp to this many lines behind Show more. Unset, the message is shown whole. */
  visibleLines?: NumberOfLines;
}

/**
 * An entry's message as Clive markdown, the way a chat message renders — in the feed's secondary
 * tone and size, with any `src:doc:` citation resolved to a document chip.
 */
const NotificationMessage: React.FC<NotificationMessageProps> = ({ message, className, visibleLines }) => {
  const content = (
    <CliveMarkdownDisplay
      content={message}
      components={COMPONENTS}
      className={cn('text-sm text-slate-800', className)}
    />
  );

  return visibleLines ? (
    <ShowAllCollapsible
      visibleLines={visibleLines}
      showAsInlineButton
      expandLabel="Show more"
      collapseLabel="Show less"
    >
      {content}
    </ShowAllCollapsible>
  ) : (
    content
  );
};

export default NotificationMessage;
